import { EnvConfig } from '../types';

const stagingConfig: EnvConfig = {
  // SENTRY
  SENTRY_ENV: 'staging',

  // GTM
  GTM_ENABLED: false,

  // GHOST
  GHOST_URL: 'https://ghost.reas.cz',
  GHOST_CONTENT_KEY: '7f0617108ac3404ad1b5e93a18',

  DISABLED_FEATURES: {},
};

export default stagingConfig;
